import { useState } from 'react';
import { SelectOption } from '../../searchableSelect/searchableSelectTypes';
import { useTransaction } from '../../../context/TransactionContext';
import { useFetchSkills } from '../../../hooks/useFetchSkills';
import { ITransaction } from '../../../interface/transaction';

/** The props `SearchableSelect` needs to pick a skill, from the same list the picker screen uses. */
export const useSkillSelect = () => {
  const { transaction, updateTransaction } = useTransaction();
  const [searchValue, setSearchValue] = useState('');
  const {
    data: skills,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useFetchSkills({
    sortBy: ['name:ASC'],
    pageSize: 50,
    search: searchValue,
    fields: ['name'],
  });

  const options: SelectOption[] = skills.map(({ id, name }) => ({ value: id, label: name }));
  const value: SelectOption | null = transaction?.skill?.id
    ? { value: transaction.skill.id, label: transaction.skill.name }
    : null;

  const onChange = (option: SelectOption) => {
    const skill = skills.find(({ id }) => id === option.value);
    if (!skill) return;
    updateTransaction({
      ...transaction,
      skill,
      isManualSkill: true,
      shouldLoadServerPrice: false,
    } as ITransaction);
  };

  return {
    options,
    value,
    onChange,
    onSearch: setSearchValue,
    onLoadMore: fetchNextPage,
    hasMore: Boolean(hasNextPage),
    loading: isLoading,
    loadingMore: isFetchingNextPage,
  };
};
